// App.tsx
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import MainPageLayout from "./layouts/MainPageLayout";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import GalleryPage from "./pages/GalleryPage";
import MailSendPage from "./pages/MailSendPage";


const router = createBrowserRouter([
  {
    path: "/",
    Component: MainPageLayout,
    children: [
      { index: true, Component: HomePage },
      { path: "about", Component: AboutPage },
      { path: "gallery", Component: GalleryPage },
      { path: "contact/sendsuccefully", Component: MailSendPage },
      { path: "contact", Component: ContactPage },
    ],
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}